import {getEnvironment} from "./../../components/utils/environmantDetection";
import API_CONSTANTS from './../../components/constants/constants';
import axios from 'axios';
import store from './../store';

const createLikeBody = (shareId, body) => {
    const {userId, given_name, family_name, email} = body;
    return {
        "postId": "",
        "shareId": shareId,
        userDetails: {
            firstName: given_name,
            lastName: family_name,
            email,
            userId: userId,
        }
    }
}

const getLikeId = (users, userId) => {
    for (var i = 0; i < users.length; i++) {
        if (users[i].userId === userId) {
            return users[i].id;
        }
    }
    return null;
}

const createCommentBody = (shareId, userId, commentText, body) => {
    const {given_name, family_name, email} = body;
    return {
        "postId": "",
        "shareId": shareId,
        "comment": commentText,
        "type": "string",
        userDetails: {
            firstName: given_name,
            lastName: family_name,
            email,
            userId
        }
    }
}

const creatLikeCommentBody = (shareId, body) => {
    const {given_name, family_name, email} = body;
    return {
        postId: body.postId ? body.postId : "",
        shareId: shareId,
        userDetails: {
            firstName: given_name,
            lastName: family_name,
            email,
            userId: body.userId,
        }
    }
}

const createEditBody = (shareId, body) => {
    const {given_name, family_name, email} = body;
    return {
        "postId": "",
        shareId: shareId,
        "comment": body.commentText,
        "type": "string",
        userDetails: {
            firstName: given_name,
            lastName: family_name,
            email,
            userId: body.userId,
        }
    }
}
const defaultHeaders = {
    Authorization: store.getState().user.accessToken ? store.getState().user.accessToken : ''
}


const utils = {
    baseUrl: "https://" + getEnvironment("API") + "shutterfly.com",

    getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(
            /[?&]+([^=&]+)=([^&]*)/gi,
            function (m, key, value) {
                vars[key] = value;
            }
        );
        return vars;
    },

    likeSharedProject: function (_body, users, originalSharedProjectGuid) {
        console.log('originalSharedProjectGuid', originalSharedProjectGuid);
        let shareId = this.getUrlVars()["shareid"];
        const url = API_CONSTANTS.LIKE_COMMENT_BASE_URL + (originalSharedProjectGuid ? originalSharedProjectGuid : shareId) + '/likes';
        const body = createLikeBody(shareId, _body);
        defaultHeaders.Authorization = "Bearer " + store.getState().user.accessToken;
        return axios.post(url, body, {headers: defaultHeaders});
    },

    unlikeSharedProject: function (userId, users, originalSharedProjectGuid) {
        let shareId = this.getUrlVars()["shareid"];
        const likeId = getLikeId(users, userId);
        defaultHeaders.Authorization = "Bearer " + store.getState().user.accessToken;
        const url = API_CONSTANTS.LIKE_COMMENT_BASE_URL + (originalSharedProjectGuid ? originalSharedProjectGuid : shareId) + '/likes/' + likeId + '/user/' + userId;
        return axios.delete(url, {headers: defaultHeaders});
    },

    getLikes: function (originalSharedProjectGuid) {
        console.log('getLikes-->', originalSharedProjectGuid);
        let shareId = this.getUrlVars()["shareid"];
        const url = API_CONSTANTS.LIKE_COMMENT_BASE_URL + (originalSharedProjectGuid ? originalSharedProjectGuid : shareId) + '/likes';
        defaultHeaders.Authorization = "Bearer " + store.getState().user.accessToken;

        return axios.get(url, {headers: defaultHeaders});
    },

    getComments: function (offset, limit, originalSharedProjectGuid) {
        let shareId = this.getUrlVars()["shareid"];
        defaultHeaders.Authorization = "Bearer " + store.getState().user.accessToken;
        const url = API_CONSTANTS.LIKE_COMMENT_BASE_URL + (originalSharedProjectGuid ? originalSharedProjectGuid : shareId) + '/comments?offset=' + offset + '&limit=' + limit;
        return axios.get(url, {headers: defaultHeaders});
    },

    addComment: function (body, originalSharedProjectGuid) {
        let shareId = this.getUrlVars()["shareid"];
        const url = API_CONSTANTS.LIKE_COMMENT_BASE_URL + (originalSharedProjectGuid ? originalSharedProjectGuid : shareId) + '/comments';
        const {userId, commentText} = body;
        const _body = createCommentBody(shareId, userId, commentText, body);
        defaultHeaders.Authorization = "Bearer " + store.getState().user.accessToken;
        console.log('defaultHeaders', defaultHeaders);
        return axios.post(url, _body, {headers: defaultHeaders});
    },

    /**
     * This function gets user details based on he/she is logged in or not
     */
    getUsersData: function () {
        let env = getEnvironment();
        if (env !== "prod.") {
            env = "." + env;
        } else {
            env = ".";
        }
        let user;
        let baseUrl = "https://www" + env + "shutterfly.com/userstate/query.sfly";
        if (!window.evalUseNewAuth) {
            return (new Promise((res, rej) => {
                rej('404');
            }));
        }
        return window.evalUseNewAuth()
            .then(useNewAuth => {
                if (useNewAuth) {
                    return window.$sflyAuth.getIdToken()
                        .then(_user => {
                            user = window.$sflyAuth.getCurrentUser();
                            user.accessToken = _user.jwtToken;
                            return user;

                        })
                } else {
                    // Use the old way of logging in
                    return axios.get(baseUrl).then((data) => {
                        console.log('second daata', data);
                    });
                }
            })
    },
    /**
     * @param {Object} currentUser
     * @param {Array} users
     * This function checks if currentUser is already present in array of users
     */
    checkIfAlreadyLiked: function (currentUser, users) {
        if (!users || !(users instanceof Array) || !currentUser) {
            return false;
        }
        for (var i = 0; i < users.length; i++) {
            if (users[i].userId === currentUser) {
                return true;
            }
        }
        return false;
    },

    /**
     * @param {String} comment
     * @param {Object} body
     * This function calls the services for liking givin comment by logged In user
     */
    likeComment: function (commentId, body, originalSharedProjectGuid) {
        let shareId = this.getUrlVars()["shareid"];
        const url = API_CONSTANTS.LIKE_COMMENT_BASE_URL + (originalSharedProjectGuid ? originalSharedProjectGuid : shareId) + '/comments/' + commentId + '/likes';
        var _body = creatLikeCommentBody(shareId, body);
        defaultHeaders.Authorization = "Bearer " + store.getState().user.accessToken;
        return axios.post(url, _body, {headers: defaultHeaders});
    },

    /**
     *
     * @param {String} commentId
     * @param {String} likeId
     * @param {String} userId
     * This function calls the service to unlike the comments by loggedIn user
     */
    unlikeComment: function (commentId, likeId, userId, originalSharedProjectGuid) {
        let shareId = this.getUrlVars()["shareid"];
        const url = API_CONSTANTS.LIKE_COMMENT_BASE_URL + (originalSharedProjectGuid ? originalSharedProjectGuid : shareId) + '/comments/'
            + commentId + '/likes/' + likeId + '/user/' + userId;
        defaultHeaders.Authorization = "Bearer " + store.getState().user.accessToken;
        return axios.delete(url, {headers: defaultHeaders});
    },

    /**
     *
     * @param { String } commentId
     * @param { String } userId
     * calls delete comment API for given comment by given user
     */
    deleteComment: function (commentId, userId, originalSharedProjectGuid) {
        let shareId = this.getUrlVars()["shareid"];
        const url = API_CONSTANTS.LIKE_COMMENT_BASE_URL + (originalSharedProjectGuid ? originalSharedProjectGuid : shareId) + '/comments/'
            + commentId + '/user/' + userId;
        defaultHeaders.Authorization = "Bearer " + store.getState().user.accessToken;
        return axios.delete(url, {headers: defaultHeaders});
    },

    /**
     *
     * @param {*} body
     * @param {*} originalSharedProjectGuid
     * Does: edit the comment based on body and originalProjectGuid
     */
    editComment: function (body, originalSharedProjectGuid) {
        let shareId = this.getUrlVars()["shareid"];
        const url = API_CONSTANTS.LIKE_COMMENT_BASE_URL + (originalSharedProjectGuid ? originalSharedProjectGuid : shareId) + '/comments/' + body.id;
        defaultHeaders.Authorization = "Bearer " + store.getState().user.accessToken;
        var _body = createEditBody(shareId, body);
        return axios.put(url, _body, {headers: defaultHeaders})
    },

    /**
     * @param {*} originalSharedProjectGuid
     * Does: Calls the enspoint to get the total comments
     */
    getCommentCount: function (originalSharedProjectGuid) {
        let shareId = this.getUrlVars()["shareid"];
        defaultHeaders.Authorization = "Bearer " + store.getState().user.accessToken;
        const url = API_CONSTANTS.LIKE_COMMENT_BASE_URL + (originalSharedProjectGuid ? originalSharedProjectGuid : shareId) + '/comments/count';
        return axios.get(url, {headers: defaultHeaders});
    }

}

export default utils;